exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3dce7641] .el-form{\n  width: 7.73333rem;\n}\n", ""]);

// exports
